import type { AccountOverrideEntryRequest } from "@common/schemas/domains/accounting/account-override.schema";
import { buildLedgerOverride } from "@lib/accountOverrides";

export function buildLineItemAccountUpdate({
    selectedAccountId,
    accrualLedgerId,
}: {
    selectedAccountId: string | null;
    accrualLedgerId?: string;
}): {
    accountOverrides?: AccountOverrideEntryRequest[];
    accountId?: string | null;
} {
    if (accrualLedgerId) {
        return {
            accountOverrides: buildLedgerOverride(
                accrualLedgerId,
                selectedAccountId,
            ),
        };
    }

    return { accountId: selectedAccountId };
}
